import React, { useMemo } from "react";
import { DayPicker } from "react-day-picker";
import styled, { css } from "styled-components";
import "react-day-picker/style.css";
import { isValidDate, toDateObject, adjustFormat } from "util/DateTime";
const StyledDayPicker = styled(DayPicker)(
  ({ theme }) => css`
    width: 100%;

    --rdp-accent-color: ${theme.colors.variant.primary};
    --rdp-disabled-opacity: 0.4;

    .rdp-chevron {
      fill: ${theme.colors.gray[60]};
    }
  `
);
const useSelectedDate = (date) => useMemo(() => {
  const isDateValid = !date || isValidDate(toDateObject(date, ["date"]));
  if (isDateValid) {
    return date;
  }
  return void 0;
}, [date]);
const DatePicker = ({ date = void 0, fromDate = void 0, onChange, showOutsideDays = false }) => {
  const selectedDate = useSelectedDate(date);
  const modifiers = useMemo(
    () => ({
      selected: (moddedDate) => {
        if (!selectedDate) {
          return false;
        }
        return selectedDate === adjustFormat(moddedDate, "date");
      },
      disabled: {
        before: new Date(fromDate)
      }
    }),
    [fromDate, selectedDate]
  );
  return /* @__PURE__ */ React.createElement(
    StyledDayPicker,
    {
      defaultMonth: selectedDate ? toDateObject(selectedDate).toDate() : void 0,
      onDayClick: onChange,
      modifiers,
      timeZone: "UTC",
      showOutsideDays
    }
  );
};
export default DatePicker;
